var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: _vm.load,
      expression: "load"
    }],
    attrs: {
      "infinite-scroll-disabled": "disabled",
      "infinite-scroll-distance": "96"
    }
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Items')))]), _c('div', {
    staticClass: "px-4"
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('Type'),
      "items": _vm.types,
      "dense": ""
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1), _vm._l(_vm.categorys.slice(0, _vm.show), function (category) {
    return _c('div', {
      key: "items-category-".concat(category)
    }, [_c('v-divider', {
      staticClass: "mb-4"
    }), _c('Category', {
      attrs: {
        "id": category
      }
    })], 1);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }